import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../shared/services/debug.service.js';
import { style } from './step-communication.style.js';
import { ApplicationService } from '../../../services/application.service.js';
import './phone/phone.component.js';
import './email/email.component.js';
import { globalStyle } from '../../../global-styles.style.js';
import { REFI_PERSONAL_CONST } from '../../../shared/constants/app.constants.js';
import { validateForm } from '../../../shared/decorators/validate-form.decorator.js';
import { stratum } from '../../../../constants/stratum.js';

class RefiStepNameComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepCommunication');
    this.application = {};
    this.validity = {};
    this.useTextOptIn = false;
    this.childIds = {
      email: 'email-input',
      phone: 'phone-input',
      textOptIn: 'text-opt-in-input',
    };
    this.childIds = {
      email: 'email-input',
      phone: 'phone-input',
      textOptIn: 'text-opt-in-input',
    };
  }

  static properties = {
    application: { type: Object, reflect: true },
    applicant: { type: Object, reflect: true },
    isPrefill: { type: Boolean, attribute: 'is-prefill' },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
  };

  static styles = [style, globalStyle];

  connectedCallback() {
    super.connectedCallback();
    this.application = ApplicationService.Application;
    this.applicant = this.isPrimary
      ? this.application.primaryApplicant
      : this.application.coApplicant;
    this.coAppPrefix = this.isPrimary ? '' : 'co-';
    this.useTextOptIn =
      this.isPrimary &&
      this.application.profileType === REFI_PERSONAL_CONST.FINANCIAL;
    // validate
    stratum.publishTag(
      this.isPrimary
        ? TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COMMUNICATION
        : TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_COMMUNICATION
    );
  }

  render() {
    return html`
      <form
        id="step-communication-form"
        class="step-communication-form"
        @submit="${this.onSubmit}"
        novalidate
      >
        <refi-heading>
          ${this.isPrimary
            ? html`${this.isPrefill
                ? html`Thanks ${this.applicant.firstName}! Please confirm your
                  contact information.`
                : html`Nice to meet you ${this.applicant.firstName}! How can we
                  reach you?`}`
            : html` Now let us know how to communicate with your co-applicant,
              ${this.applicant.firstName}`}
        </refi-heading>

        <refi-personal-email
          id="${this.childIds.email}"
          @validity="${this.updateValidity}"
          ?is-primary="${this.isPrimary}"
          ?is-prefill="${this.isPrefill}"
        ></refi-personal-email>
        <refi-personal-phone
          id="${this.childIds.phone}"
          @validity="${this.updateValidity}"
          ?is-primary="${this.isPrimary}"
          ?text-opt-in="${this.useTextOptIn}"
          opt-in-child-id="${this.childIds.textOptIn}"
        ></refi-personal-phone>

        <div class="button-container">
          <fs-button class="fs-button next-button" variant="primary"
            >${!this.isPrefill ? html`Next` : html`Confirm`}
          </fs-button>
        </div>
      </form>
    `;
  }

  updateValidity(ev) {
    this.validity[ev.detail.name] = ev.detail.isValid;
  }

  @validateForm()
  onSubmit() {
    this.inputChildren = {
      email: this.shadowRoot.getElementById(this.childIds.email),
      phone: this.useTextOptIn
        ? this.shadowRoot
            .getElementById(this.childIds.phone)
            .shadowRoot.getElementById(this.childIds.textOptIn)
        : this.shadowRoot.getElementById(this.childIds.phone),
    };

    this.runChildrenBusinessChecks();

    stratum.publishTag(TagKey.PERSONAL_COMMUNICATION_SMS_OPT_SELECTION, {
      replacements: { value: this.applicant.smsOptIn },
    });
    let valid = true;
    this.debug.log(this.validity);
    Object.values(this.validity).forEach((validityValue) => {
      if (!validityValue) {
        valid = false;
      }
    });

    if (valid) {
      this.oldApplicantInfo = JSON.parse(JSON.stringify(this.applicant));
      Object.values(this.inputChildren).forEach((child) => {
        Object.keys(child.values).forEach((field) => {
          this.applicant[field] = child.values[field];
        });
      });
      this.applicant.confirmEmailAddress = this.applicant.emailAddress;
      this.tagFieldChangesOnSubmit();
      this.debug.log('valid', this.application);
      this.dispatchEvent(new CustomEvent('next-step'));
    }
  }

  tagFieldChangesOnSubmit() {
    Object.keys(this.applicant).forEach((field) => {
      if (
        typeof this.applicant[field] !== 'object' &&
        this.applicant[field] !== this.oldApplicantInfo[field]
      ) {
        this.debug.log(`${this.coAppPrefix}${field}`);
        stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_CHANGED_FIELD, {
          replacements: {
            value: `${this.coAppPrefix}${field}`,
          },
        });
      }
    });
  }

  runChildrenBusinessChecks() {
    this.inputChildren.email.runBusinessChecks();
  }
}

customElements.define('refi-step-communication', RefiStepNameComponent);
